import EligibilityScreen from 'features/lineOfCredit/screens/eligibility/EligibilityScreen';
import React from 'react';

export default function Page() {
  return <EligibilityScreen serializedData={undefined} />;
}
